import { api } from '@/shared/api/client';
import type { GetContentsDetailResponse } from '../model/dto';

export const getContentsDetail = async (id: string) => {
  const { data } = await api.get<GetContentsDetailResponse>(
    `/contents/${id}/`
  );
  return data;
};
